import { PageController } from '@client/components/_core/layout/PageController';
import { CommunicationTemplateEdit } from '@client/components/communication-templates/CommunicationTemplateEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/org-settings/communication/comm-templates/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New communication template',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <CommunicationTemplateEdit action={['add']} />
        </PageController>
    );
}
